import { render, staticRenderFns } from "./DepartmentFinder.vue?vue&type=template&id=4dc96c7a&"
import script from "./DepartmentFinder.vue?vue&type=script&lang=ts&"
export * from "./DepartmentFinder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports